import React from "react";
import { Button } from "@/components/ui/button";
import { Users, Eye } from "lucide-react";
import { getVerificationStatusColor } from "./utils";

export function AllPartnersTab({ partners, onViewDocuments }) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">All Partners</h2>
      
      {partners.length === 0 ? (
        <div className="text-center py-10 border border-border">
          <Users className="w-12 h-12 mx-auto text-muted-foreground/30 mb-4" />
          <p className="text-muted-foreground">No partners registered yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {partners.map((partner) => (
            <PartnerCard
              key={partner.user_id}
              partner={partner}
              onViewDocuments={onViewDocuments}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function PartnerCard({ partner, onViewDocuments }) {
  return (
    <div className="border border-border p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div>
            <p className="font-bold">{partner.company_name || partner.name}</p>
            <p className="text-sm text-muted-foreground">{partner.email}</p>
          </div>
          <span className={`px-3 py-1 text-xs font-bold uppercase ${getVerificationStatusColor(partner.verification_status || 'not_started')}`}>
            {partner.verification_status || 'Not Started'}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right text-sm">
            <p>Docs: {partner.documents_summary?.total || 0}</p>
            <p className="text-muted-foreground">
              <span className="text-green-600">{partner.documents_summary?.approved || 0} approved</span>
              {partner.documents_summary?.pending > 0 && (
                <span className="text-yellow-600 ml-2">{partner.documents_summary.pending} pending</span>
              )}
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => onViewDocuments(partner.user_id)}
            className="rounded-none"
            data-testid={`view-partner-${partner.user_id}`}
          >
            <Eye className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
